// Tokens compartilhados pelas telas de perfil social (WA / FB / IG).
export const SOCIAL_PROFILE_DESIGN = {
    page: {
        container: 'flex flex-col h-[calc(100vh-120px)] bg-slate-100 rounded-2xl border border-slate-200 shadow-sm overflow-hidden animate-in fade-in duration-300',
        topBar: 'flex items-center gap-3 px-4 py-2.5 bg-white border-b border-slate-200',
        backButton: 'flex items-center gap-1 text-sm font-medium text-slate-600 hover:text-[#7C3AED] transition-colors flex-shrink-0',
        headerTitle: 'text-sm font-bold text-slate-900 truncate',
        errorBanner: 'px-4 py-2 bg-red-50 border-b border-red-200 text-xs text-red-700 flex items-center gap-2',
        body: 'flex-1 overflow-y-auto p-4',
        panel: 'bg-white rounded-xl border border-slate-200 shadow-sm p-4',
        footer: 'border-t border-slate-200 bg-white px-4 py-2.5 flex items-center justify-end gap-2',
    },
    identity: {
        row: 'flex items-start gap-3 mb-4 pb-4 border-b border-slate-200',
        photo: 'relative flex-shrink-0',
        preview: 'w-16 h-16 rounded-xl object-cover border border-slate-200 bg-slate-50',
        previewFallback: 'w-16 h-16 rounded-xl bg-slate-100 border border-slate-200 flex items-center justify-center',
        changeBtn: 'absolute -bottom-1 -right-1 w-7 h-7 rounded-full bg-[#7C3AED] hover:bg-[#6d28d9] text-white flex items-center justify-center shadow-md ring-2 ring-white cursor-pointer disabled:opacity-60',
        fields: 'flex-1 grid grid-cols-1 sm:grid-cols-2 gap-2.5 min-w-0',
        hint: 'inline-flex items-start gap-1.5 mt-2 text-[11px] text-amber-800 bg-amber-50 border border-amber-200 rounded-lg px-2.5 py-1.5',
    },
    form: {
        grid: 'grid grid-cols-1 md:grid-cols-2 gap-x-3 gap-y-3',
        field: 'flex flex-col gap-1',
        fieldFull: 'flex flex-col gap-1 md:col-span-2',
        labelRow: 'flex items-center justify-between gap-2',
        label: 'text-[11px] font-semibold uppercase tracking-wider text-slate-600',
        counter: 'text-[10px] text-slate-400 tabular-nums',
        input: 'h-9 bg-white border-slate-300 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 rounded-lg text-sm text-slate-900 placeholder:text-slate-400',
        inputReadonly: 'h-9 bg-slate-50 border-slate-200 text-slate-700 cursor-not-allowed rounded-lg text-sm',
        textarea: 'bg-white border-slate-300 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 rounded-lg min-h-[64px] text-sm text-slate-900 placeholder:text-slate-400 resize-y',
        textareaSm: 'bg-white border-slate-300 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 rounded-lg min-h-[40px] text-sm text-slate-900 placeholder:text-slate-400 resize-none',
    },
    btn: {
        cancel: 'px-3 py-1.5 text-sm font-medium text-slate-600 hover:text-slate-900 hover:bg-slate-100 rounded-lg transition-colors',
        primary: 'flex items-center gap-1.5 px-3.5 py-1.5 bg-[#7C3AED] hover:bg-[#6d28d9] text-white text-sm font-medium rounded-lg transition-all shadow-sm shadow-[#7C3AED]/25 disabled:opacity-60',
        reload: 'text-xs text-slate-600 hover:text-[#7C3AED] font-medium flex items-center gap-1 px-2.5 py-1.5 rounded-lg hover:bg-slate-100 border border-transparent hover:border-slate-200 transition-colors',
        external: 'inline-flex items-center gap-1.5 px-3.5 py-1.5 bg-[#7C3AED] hover:bg-[#6d28d9] text-white text-sm font-medium rounded-lg transition-all shadow-sm shadow-[#7C3AED]/25',
    },
    loading: 'flex flex-col items-center justify-center flex-1 gap-2 text-sm text-slate-500',
    // Painel de metricas da Meta (SocialMetricsPanel), compartilhado por IG e FB.
    metrics: {
        wrapper: 'flex flex-col gap-4 mb-4',
        section: 'flex flex-col gap-2.5',
        sectionHead: 'flex items-center justify-between gap-2',
        sectionTitle: 'text-[11px] font-semibold uppercase tracking-wider text-slate-600 flex items-center gap-1.5',
        grid: 'grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-2.5',
        gridWide: 'grid grid-cols-2 md:grid-cols-4 gap-2.5',
        card: 'bg-white rounded-xl border border-slate-200 p-3 flex items-center gap-2.5 min-w-0',
        cardIcon: 'w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0',
        cardValue: 'text-base font-bold text-slate-900 tabular-nums leading-tight',
        cardLabel: 'text-[10px] uppercase tracking-wider text-slate-500 truncate',
        cardSub: 'text-[10px] text-slate-400',
        periodRow: 'flex items-center gap-1 bg-slate-100 rounded-lg p-0.5',
        periodChip: 'px-2.5 py-1 text-[11px] font-medium rounded-md text-slate-600 hover:text-slate-900 transition-colors',
        periodChipActive: 'px-2.5 py-1 text-[11px] font-medium rounded-md bg-[#7C3AED] text-white shadow-sm shadow-[#7C3AED]/25',
        note: 'flex items-start gap-1.5 text-[11px] text-amber-800 bg-amber-50 border border-amber-200 rounded-lg px-2.5 py-1.5',
        noteMuted: 'flex items-start gap-1.5 text-[11px] text-slate-500 bg-slate-50 border border-slate-200 rounded-lg px-2.5 py-1.5',
        noteAction: 'font-semibold underline underline-offset-2 hover:text-[#7C3AED] transition-colors',
        chartBox: 'bg-white rounded-xl border border-slate-200 p-3',
        chartTitle: 'text-[10px] uppercase tracking-wider text-slate-500 mb-1',
        chartGrid: 'grid grid-cols-1 md:grid-cols-2 gap-2.5',
        table: 'w-full text-xs bg-white rounded-xl border border-slate-200 overflow-hidden',
        th: 'text-left px-3 py-2 text-[10px] font-semibold uppercase tracking-wider text-slate-500 bg-slate-50',
        td: 'px-3 py-2 text-slate-700 tabular-nums border-t border-slate-100',
        barRow: 'flex items-center gap-2 text-[11px]',
        barTrack: 'flex-1 h-2 rounded-full bg-slate-100 overflow-hidden',
        barFill: 'h-full rounded-full bg-[#7C3AED]',
        barValue: 'text-slate-500 tabular-nums w-14 text-right flex-shrink-0',
        barLabel: 'text-slate-700 truncate w-28 flex-shrink-0',
        footer: 'flex flex-wrap items-center gap-x-3 gap-y-1 text-[10px] text-slate-400',
        staleBanner: 'flex items-center gap-1.5 text-[11px] text-slate-600 bg-slate-100 border border-slate-200 rounded-lg px-2.5 py-1.5',
        collapseBtn: 'flex items-center gap-1 text-[11px] font-semibold uppercase tracking-wider text-slate-600 hover:text-[#7C3AED] transition-colors',
        skeleton: 'h-[62px] rounded-xl bg-slate-100 animate-pulse',
    },
};

// Tons dos cards de metrica — hex fixo porque as classes sao geradas por
// lookup, e o Tailwind nao consegue purgar classes montadas em runtime.
export const METRIC_TONES = {
    violet: { bg: 'bg-violet-50', text: 'text-violet-600' },
    blue: { bg: 'bg-blue-50', text: 'text-blue-600' },
    green: { bg: 'bg-green-50', text: 'text-green-600' },
    amber: { bg: 'bg-amber-50', text: 'text-amber-600' },
    rose: { bg: 'bg-rose-50', text: 'text-rose-600' },
    slate: { bg: 'bg-slate-100', text: 'text-slate-500' },
};
